import {  put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../components/common/apiConfig";
import { handleNotificationAlertCatch , handleNotificationAlertTrySelect } from "../../../components/method/handleNotificationAlert";


export const actionTypes = {
    selectComprehensiveContract: "selectComprehensiveContract [Action]",
    selectComprehensiveContractLoading: "selectComprehensiveContractLoading [Action]",
    selectComprehensiveContractAsync: "selectComprehensiveContractAsync [Action]",
    selectComprehensiveContractEmpty: "selectComprehensiveContractEmpty [Action]",
};

const inistiaState = {
    data: {},
    total:0,
    loading: false
};

export const reducerselectComprehensiveContract = (state = inistiaState, { type, payload }) => {
    switch (type) {
        case actionTypes. selectComprehensiveContract:
            return {
                ...state,
                data: payload.image_file,
                total: payload.image_file ? Object?.keys(payload.image_file)?.length :0
            };
        case actionTypes.selectComprehensiveContractLoading:
            return {
                ...state,
                loading: payload,
            };
        case actionTypes.selectComprehensiveContractEmpty:
            return inistiaState
        default:
            return state;
    }
};

function* handleWorker({ payload }) {

    yield put({ type: actionTypes.selectComprehensiveContractLoading, payload: true })


    let config = {
        url: "select_request"
    };

    let data = {
        table: "brokercustomer",
        method_type: "select_comprehensive_contract",
        data: payload?.data ? payload.data : {},
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) {
            return;
        }

        
        yield put({ type: actionTypes.selectComprehensiveContract, payload: res?.data?.response?.data})
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.selectComprehensiveContractLoading, payload: false })

    }
}

export function* workerselectComprehensiveContract() {
    yield takeLatest(actionTypes.selectComprehensiveContractAsync, handleWorker);
}
